var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#06004a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.02-111.87v-43.11l60-40q-59.24-2.39-99.62-45.4t-40.38-103.45V-721.2q0-85.94 78.56-125.96 78.55-40.01 247.33-40.01 174.88 0 250.59 38.53 75.72 38.54 75.72 127.44v377.37q0 60.44-40.5 103.45-40.5 43.01-99.5 45.4l60 40v43.11h-492.2Zm-11.87-432.17H454v-155H222.15v155Zm291.85 0h223.85v-155H514v155ZM336.25-315q22.71 0 38.83-16.06 16.12-16.06 16.12-39T375.02-409q-16.18-16-38.88-16-22.94 0-38.94 16.06-16 16.06-16 39T297.25-331q16.06 16 39 16Zm287.85 0q22.7 0 38.82-16.06t16.12-39q0-22.94-16.17-38.94-16.18-16-38.89-16-22.94 0-38.94 16.06-16 16.06-16 39T585.1-331q16.06 16 39 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportIcon);
export default __webpack_public_path__ + "static/media/transport-icon.088afab36abdf4640c456bf24d04ad46.svg";
export { ForwardRef as ReactComponent };